import { render, staticRenderFns } from "./onEign.vue?vue&type=template&id=70e36006&scoped=true"
import script from "./onEign.vue?vue&type=script&lang=js"
export * from "./onEign.vue?vue&type=script&lang=js"
import style0 from "./onEign.vue?vue&type=style&index=0&id=70e36006&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70e36006",
  null
  
)

export default component.exports